import { useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { apiClient } from '../../utils/api';
import { toastNotify } from '../../utils/toastNotify';

export const useExpenseApi = () => {
  const { user } = useAuth();

  const createExpense = useCallback(async (expenseData) => {
    const headers = {};
    
    // Add telegram ID header if user is authenticated
    if (user?.telegramId) {
      headers['x-telegram-id'] = user.telegramId.toString();
    }

    const response = await apiClient.post('/api/expenses', expenseData, { headers });
    return response.data;
  }, [user]);

  return {
    createExpense
  };
};

